import { httpClientOmni } from "@/libraries";

export default {
  async getCountRoomByStatus(data) {
    return await httpClientOmni.post("/room/get-count-room-by-status", data);
  },
  async getRoomList(params) {
    return await httpClientOmni.get("/room/get-room-list-new-v2", {
      params,
    });
  },
  async getRoomListV3(body) {
    return await httpClientOmni.post("/room/get-room-list-v3", body);
  },
  async setRoomasRead(body) {
    return await httpClientOmni.post("/message/room-read-message", body);
  },
  async setLivechatTicket(payload) {
    return await httpClientOmni.post("/livechat/set-ticket", payload);
  },
  async getCustomer(userId) {
    const response = await httpClientOmni.post("livechat/handle", {
      agent_id: userId,
    });
    return response;
  },
  async fetchUnservedRoom() {
    const response = await httpClientOmni.post("livechat/unserved-room");
    return response;
  },
  async getRoomLink(payload) {
    let res = "";
    await httpClientOmni
      .post("v3/livecall/get-room", {
        room_id: payload,
      })
      .then((response) => {
        console.log("response.data.data", response.data.data);
        res = response.data.data;
      });

    return res;
  },

  async chatCount() {
    const response = await httpClientOmni.post("room/count");
    return response;
  },

  setLabelToSession(payload) {
    const response = httpClientOmni.post(
      "settings/conversation-label/set-to-session",
      {
        room_id: payload.room_id,
        conversation_label_id: payload.id,
      }
    );
    return response;
  },

  // broadcast filter API
  async getBroadcastFilter(body) {
    let path = `v3/broadcast/get-list?paginated=true&per_page=10&page=${body.page}`
    if (body?.filterText) {
      path += `&filterText=${body.filterText}`
    }
    return await httpClientOmni.get(path);
  },
  // assign by filter API
  async getAssignBy(body) {
    let path = `agent/get-list?paginated=true&per_page=10&page=${body.page}`
    if (body?.filterText) {
      path += `&filterText=${body.filterText}`
    }
    return await httpClientOmni.get(path);
  },

  // pin API
  async getPinChat(body) {
    return await httpClientOmni.get("room/pin", body);
  },

  setPinChat(payload) {
    const response = httpClientOmni.post("room/pin", {
      room_id: payload,
    });
    return response;
  },

  setUnpinChat(payload) {
    const response = httpClientOmni.post("room/unpin", {
      room_id: payload,
    });
    return response;
  },
  // pin API
};
